import * as React from 'react';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

// Utils
import { FormatDate } from '../../../../utils/formatDate';
import { useTranslation } from 'react-i18next'
import { InputContainer, InputText } from '../SearchBarWorkflow/styles';

export const SearchBarRoles = ({
    setFilteredRequest,
    rows,
}) => {

    const { t } = useTranslation();
    const [search, setSearch] = React.useState('')
    const {format} = new FormatDate();

    function handleSearch(e) {
        setSearch(e)
        filterSearch(e)
    }

    const filterSearch = (data) => {
        let searchResults = rows.filter(e => {
            e.isEnabledStr = e.isActive ? t('system.active') : t('system.inactive');
            if (e.id.toString().toLowerCase().includes(data.toLowerCase())
                || e.name?.toString().toLowerCase().includes(data.toLowerCase())
                || e.description?.toString().toLowerCase().includes(data.toLowerCase())
                || e.createdAt?.toString().toLowerCase().includes(data.toLowerCase())
                || e.isEnabledStr.toString().toLowerCase().includes(data.toLowerCase())
            ) {
                return e
            }
        })
        setFilteredRequest(searchResults)
    }

    React.useEffect(() => {
        setFilteredRequest(rows);
        handleSearch(search);
    }, [rows])

    return (
		<InputContainer
			component="form"
			elevation={0}
		>
			<IconButton type="button" sx={{ p: '5px' }} aria-label="search" disabled>
				<SearchIcon />
			</IconButton>
			<Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
			<InputText
                type='text'
                name='search'
                value={search}
                onChange={e => handleSearch(e.target.value)}
                autoComplete='off'
                sx={{ display: 'flex', flex: 1, ml: 1, }}
                placeholder={t('system.permissions.searchBar')}
				inputProps={{ 'aria-label': 'search google maps' }}
			/>
		</InputContainer>
    );
}